import React from 'react'
import styled from 'styled-components'

const Title = styled.h1`
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: #253163;
  margin: 0 0 24px;

  :after {
    content: '';
    display: block;
    border-radius: 3px;
    margin-top: 12px;
    width: 24px;
    height: 5px;
    background-color: #1cdba1;
  }
`

export const HeadingWithDash = ({ text }) => <Title>{text}</Title>
